<template lang="pug">
    .modal-overlay(v-if="show")
      .modal-content
        .modal-header
          h3 Confirmar Exclusão
        .modal-body
          p Tem certeza que deseja excluir este tipo de documento?
        .modal-footer
          button(type="button" @click="confirmDelete") Sim, excluir
          button(type="button" @click="$emit('close')") Não, cancelar
  </template>

<script>
import { deletarTiposDocumentos } from '@/services/tipo-documento.service';

export default {
    name: 'ConfirmaDelecaoModal',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        documentId: {
            type: Number,
            required: true
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async confirmDelete() {
            try {
                await deletarTiposDocumentos(this.documentId);
                this.$emit('confirm');
            } catch (error) {
                console.error('Erro ao excluir tipo de documento:', error);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.modal-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;

}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 10px;
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
}

button[type="button"] {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

button[type="button"]:first-child {
  background-color: var(--primary-green);
  color: #fff;

  &:hover {
    background-color: var(--primary-green);
  }
}

button[type="button"]:last-child {
  background-color: #ccc;
  color: #000;

  &:hover {
    background-color: #aaa;
  }
}
</style>
